module.exports = __webpack_public_path__ + "static/img/vipchartactive.51811b94.png";